export default "__VITE_ASSET__BR3engcr__"